/**
 * AUTO-GENERATED at build time by `scripts/generate-api-config.mjs`.
 *
 * Committed with the dev project's URL so local `vite dev` and unit tests
 * work without a build step first; each `npm run app crm-app build:<stage>`
 * overwrites it with that stage's own Cloud Functions URL.
 * Do NOT hand-edit — local builds will leave this file dirty in the working
 * tree, which is expected and cosmetic (CI never commits it).
 */
export interface ApiConfig {
  /** submitWebsiteContactForm's deployed URL for this stage (PLN-1173). */
  readonly contactFormUrl: string;
  /** The stage's public price book, which a stage build bakes (PRD-1553). */
  readonly pricingUrl: string;
  /** Cloudflare Turnstile site key for the contact form (#1759, DATA-043). */
  readonly turnstileSiteKey: string;
}

export const API_CONFIG: ApiConfig = {
  contactFormUrl: 'https://europe-west3-zetl-crm-prod.cloudfunctions.net/submitWebsiteContactForm',
  pricingUrl: 'https://europe-west3-zetl-crm-prod.cloudfunctions.net/getPublicPricing/pricing/active.json',
  turnstileSiteKey: '0x4AAAAAAFd8c4srrI8xZB3V',
};
